import { IsEditMode } from "lib/@components/edit-mode"
import { AuthoringAddTaskButton } from "./authoring-add-task-button"
import { AuthoringDeleteTaskButton } from "./authoring-delete-task-button"
import { AmendsBoundaryTaskButton } from "authoring/routes/project/amends/components/amends-boundary-task-button"
import { ContextMenuBar } from "lib/@components/context-menu-bar"

export { AuthoringAddTaskButton } from "./authoring-add-task-button"

export function AuthoringTaskRowEndActions() {
    return (
        <IsEditMode>
            <AmendsBoundaryTaskButton />
            <AuthoringAddTaskButton />
            <AuthoringDeleteTaskButton />
            <ContextMenuBar type="task" />
        </IsEditMode>
    )
}
